'use client';
import { Box, useMediaQuery } from '@mui/material';
// import { Providers } from './providers';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <html lang='en' style={{ height: '100%' }}>
      <body style={{ margin: 0, height: '100%' }}>
        {/* <Providers> */}
        <Box
          sx={{
            display: 'flex',
            height: '100dvh',
            maxHeight: '100dvh',
            minHeight: 0,
            width: '100%',
            overflow: 'hidden',
            flexDirection: isMobile ? 'column' : 'row',
          }}
        >
          {children}
        </Box>
        {/* </Providers> */}
      </body>
    </html>
  );
}
